import React from "react";
import { InputJson, Button } from "nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import EmployeeEarningsFormPresenter from "./EmployeeEarningsFormPresenter";
import ApEarningsPage from "./ap-earnings/ApEarningsPage";
import BasicEarningsPage from "./basic-earnings/BasicEarningsPage";

class EmployeeEarningsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      fetchPayrolls: {},
    };
    this.presenter = new EmployeeEarningsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "employees";
  }

  render() {
    const { object, fetchPayrolls } = this.state;
    const { closeFloating, panelInfo } = this.props;
    const label = panelInfo?.payrollType === "ap" ? "AP" : "Basic";

    // console.log("panelInfo", panelInfo);

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <FloatingForm width="85%">
          <CardView style={{ padding: 0 }}>
            <h4 className="p-2 m-0 text-primary">{label} Earnings</h4>
            <hr className="m-0 mb-2"></hr>
            <form
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {panelInfo?.payrollType === "ap" ? (
                <ApEarningsPage
                  fetchPayrolls={fetchPayrolls}
                  panelInfo={panelInfo}
                />
              ) : (
                <BasicEarningsPage
                  fetchPayrolls={fetchPayrolls}
                  panelInfo={panelInfo}
                />
              )}
              <hr></hr>
              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <Button onClick={() => closeFloating()}>Cancel</Button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}

export default withRouter(EmployeeEarningsFormPage);
